import React, { useState, useRef, useEffect } from 'react';
import { AlertCircle, Upload, Info, X, Search, ChevronDown, Phone, DollarSign } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import heic2any from 'heic2any';
import '@babel/polyfill'; // For better browser compatibility



// Brand data from BrandsAndVehicles component
const brands = [
  { img: '/brands/9ff.png', name: '9ff' },
  { img: '/brands/abadal.png', name: 'Abadal' },
  { img: '/brands/abarth.png', name: 'Abarth' },
  { img: '/brands/abbott-detroit.png', name: 'Abbott Detroit' },
  { img: '/brands/abt.png', name: 'ABT' },
  { img: '/brands/ac.png', name: 'AC' },
  { img: '/brands/acura.png', name: 'Acura' },
  { img: '/brands/aiways.png', name: 'Aiways' },
  { img: '/brands/aixam.png', name: 'Aixam' },
  { img: '/brands/alfa-romeo.png', name: 'Alfa Romeo' },
  { img: '/brands/alpina.png', name: 'Alpina' },
  { img: '/brands/alpine.png', name: 'Alpine' },
  { img: '/brands/alta.png', name: 'Alta' },
  { img: '/brands/alvis.png', name: 'Alvis' },
  { img: '/brands/amc.png', name: 'AMC' },
  { img: '/brands/apollo.png', name: 'Apollo' },
  { img: '/brands/arash.png', name: 'Arash' },
  { img: '/brands/arcfox.png', name: 'Arcfox' },
  { img: '/brands/ariel.png', name: 'Ariel' },
  { img: '/brands/aro.png', name: 'Aro' },
  { img: '/brands/arrinera.png', name: 'Arrinera' },
  { img: '/brands/arrival.png', name: 'Arrival' },
  { img: '/brands/artega.png', name: 'Artega' },
  { img: '/brands/ascari.png', name: 'Ascari' },
  { img: '/brands/askam.png', name: 'Askam' },
  { img: '/brands/aspark.png', name: 'Aspark' },
  { img: '/brands/aston-martin.png', name: 'Aston Martin' },
  { img: '/brands/atalanta.png', name: 'Atalanta' },
  { img: '/brands/auburn.png', name: 'Auburn' },
  { img: '/brands/audi-sport.png', name: 'Audi Sport' },
  { img: '/brands/audi.png', name: 'Audi' },
  { img: '/brands/austin.png', name: 'Austin' },
  { img: '/brands/autobacs.png', name: 'Autobacs' },
  { img: '/brands/autobianchi.png', name: 'Autobianchi' },
  { img: '/brands/axon.png', name: 'Axon' },
  { img: '/brands/bac.png', name: 'Bac' },
  { img: '/brands/baic-motor.png', name: 'Baic Motor' },
  { img: '/brands/baojun.png', name: 'Baojun' },
  { img: '/brands/beiben.png', name: 'Beiben' },
  { img: '/brands/bentley.png', name: 'Bentley' },
  { img: '/brands/berkeley.png', name: 'Berkeley' },
  { img: '/brands/berliet.png', name: 'Berliet' },
  { img: '/brands/bertone.png', name: 'Bertone' },
  { img: '/brands/bestune.png', name: 'Bestune' },
  { img: '/brands/bharatbenz.png', name: 'Bharatbenz' },
  { img: '/brands/bitter.png', name: 'Bitter' },
  { img: '/brands/bizzarrini.png', name: 'Bizzarrini' },
  { img: '/brands/bmw-m.png', name: 'BMW M' },
  { img: '/brands/bmw.png', name: 'BMW' },
  { img: '/brands/borgward.png', name: 'Borgward' },
  { img: '/brands/bowler.png', name: 'Bowler' },
  { img: '/brands/brabus.png', name: 'Brabus' },
  { img: '/brands/brammo.png', name: 'Brammo' },
  { img: '/brands/brilliance.png', name: 'Brilliance' },
  { img: '/brands/bristol.png', name: 'Bristol' },
  { img: '/brands/brooke.png', name: 'Brooke' },
  { img: '/brands/bufori.png', name: 'Bufori' },
  { img: '/brands/bugatti.png', name: 'Bugatti' },
  { img: '/brands/buick.png', name: 'Buick' },
  { img: '/brands/byd.png', name: 'BYD' },
  { img: '/brands/byton.png', name: 'Byton' },
  { img: '/brands/cadillac.png', name: 'Cadillac' },
  { img: '/brands/camc.png', name: 'Camc' },
  { img: '/brands/canoo.png', name: 'Canoo' },
  { img: '/brands/caparo.png', name: 'Caparo' },
  { img: '/brands/carlsson.png', name: 'Carlsson' },
  { img: '/brands/caterham.png', name: 'Caterham' },
  { img: '/brands/changan.png', name: 'Changan' },
  { img: '/brands/changfeng.png', name: 'Changfeng' },
  { img: '/brands/chery.png', name: 'Chery' },
  { img: '/brands/chevrolet-corvette.png', name: 'Chevrolet Corvette' },
  { img: '/brands/chevrolet.png', name: 'Chevrolet' },
  { img: '/brands/chrysler.png', name: 'Chrysler' },
  { img: '/brands/cisitalia.png', name: 'Cisitalia' },
  { img: '/brands/citroen.png', name: 'Citroen' },
  { img: '/brands/cizeta.png', name: 'Cizeta' },
  { img: '/brands/cole.png', name: 'Cole' },
  { img: '/brands/wolkswagen.png', name: 'Wolkswagen' },
  { img: '/brands/corre-la-licorne.png', name: 'Corre La Licorne' },
  { img: '/brands/dacia.png', name: 'Dacia' },
  { img: '/brands/daewoo.png', name: 'Daewoo' },
  { img: '/brands/daf.png', name: 'Daf' },
  { img: '/brands/daihatsu.png', name: 'Daihatsu' },
  { img: '/brands/daimler.png', name: 'Daimler' },
  { img: '/brands/dartz.png', name: 'Dartz' },
  { img: '/brands/datsun.png', name: 'Datsun' },
  { img: '/brands/david-brown.png', name: 'David Brown' },
  { img: '/brands/dayun.png', name: 'Dayun' },
  { img: '/brands/de-tomaso.png', name: 'De Tomaso' },
  { img: '/brands/delage.png', name: 'Delage' },
  { img: '/brands/desoto.png', name: 'Desoto' },
  { img: '/brands/detroit-electric.png', name: 'Detroit Electric' },
  { img: '/brands/devel-sixteen.png', name: 'Devel Sixteen' },
  { img: '/brands/diatto.png', name: 'Diatto' },
  { img: '/brands/dina.png', name: 'Dina' },
  { img: '/brands/dkw.png', name: 'DKW' },
  { img: '/brands/dmc.png', name: 'DMC' },
  { img: '/brands/dodge-viper.png', name: 'Dodge Viper' },
  { img: '/brands/dodge.png', name: 'Dodge' },
  { img: '/brands/dongfeng.png', name: 'Dongfeng' },
  { img: '/brands/donkervoort.png', name: 'Donkervoort' },
  { img: '/brands/drako.png', name: 'Drako' },
  { img: '/brands/ds.png', name: 'DS' },
  { img: '/brands/duesenberg.png', name: 'Duesenberg' },
  { img: '/brands/eagle.png', name: 'Eagle' },
  { img: '/brands/edag.png', name: 'Edag' },
  { img: '/brands/edsel.png', name: 'Edsel' },
  { img: '/brands/eicher.png', name: 'Eicher' },
  { img: '/brands/elemental.png', name: 'Elemental' },
  { img: '/brands/elfin.png', name: 'Elfin' },
  { img: '/brands/elva.png', name: 'Elva' },
  { img: '/brands/englon.png', name: 'Englon' },
  { img: '/brands/erf.png', name: 'ERF' },
  { img: '/brands/eterniti.png', name: 'Eterniti' },
  { img: '/brands/exeed.png', name: 'Exeed' },
  { img: '/brands/facel-vega.png', name: 'Facel Vega' },
  { img: '/brands/faraday-future.png', name: 'Faraday Future' },
  { img: '/brands/faw-jiefang.png', name: 'Faw Jiefang' },
  { img: '/brands/faw.png', name: 'Faw' },
  { img: '/brands/ferrari.png', name: 'Ferrari' },
  { img: '/brands/fiat.png', name: 'Fiat' },
  { img: '/brands/fioravanti.png', name: 'Fioravanti' },
  { img: '/brands/fisker.png', name: 'Fisker' },
  { img: '/brands/foden.png', name: 'Foden' },
  { img: '/brands/force-motors.png', name: 'Force Motors' },
  { img: '/brands/ford-mustang.png', name: 'Ford Mustang' },
  { img: '/brands/ford.png', name: 'Ford' },
  { img: '/brands/foton.png', name: 'Foton' },
  { img: '/brands/fpv.png', name: 'FPV' },
  { img: '/brands/franklin.png', name: 'Franklin' },
  { img: '/brands/freightliner.png', name: 'Freightliner' },
  { img: '/brands/fso.png', name: 'FSO' },
  { img: '/brands/gac-group.png', name: 'GAC Group' },
  { img: '/brands/gardner-douglas.png', name: 'Gardner Douglas' },
  { img: '/brands/gaz.png', name: 'Gaz' },
  { img: '/brands/geely.png', name: 'Geely' },
  { img: '/brands/general-motors.png', name: 'General Motors' },
  { img: '/brands/genesis.png', name: 'Genesis' },
  { img: '/brands/geo.png', name: 'Geo' },
  { img: '/brands/geometry.png', name: 'Geometry' },
  { img: '/brands/gilbern.png', name: 'Gilbern' },
  { img: '/brands/gillet.png', name: 'Gillet' },
  { img: '/brands/ginetta.png', name: 'Ginetta' },
  { img: '/brands/gmc.png', name: 'GMC' },
  { img: '/brands/golden-dragon.png', name: 'Golden Dragon' },
  { img: '/brands/gonow.png', name: 'Gonow' },
  { img: '/brands/great-wall.png', name: 'Great Wall' },
  { img: '/brands/grinnall.png', name: 'Grinnall' },
  { img: '/brands/gumpert.png', name: 'Gumpert' },
  { img: '/brands/hafei.png', name: 'Hafei' },
  { img: '/brands/haima.png', name: 'Haima' },
  { img: '/brands/haval.png', name: 'Haval' },
  { img: '/brands/hawtai.png', name: 'Hawtai' },
  { img: '/brands/hennessey.png', name: 'Hennessey' },
  { img: '/brands/higer.png', name: 'Higer' },
  { img: '/brands/hillman.png', name: 'Hillman' },
  { img: '/brands/hindustan-motors.png', name: 'Hindustan Motors' },
  { img: '/brands/hino.png', name: 'Hino' },
  { img: '/brands/hiphi.png', name: 'Hiphi' },
  { img: '/brands/hispano-suiza.png', name: 'Hispano Suiza' },
  { img: '/brands/holden.png', name: 'Holden' },
  { img: '/brands/hommell.png', name: 'Hommell' },
  { img: '/brands/honda.png', name: 'Honda' },
  { img: '/brands/hongqi.png', name: 'Hongqi' },
  { img: '/brands/hongyan.png', name: 'Hongyan' },
  { img: '/brands/horch.png', name: 'Horch' },
  { img: '/brands/hsv.png', name: 'HSV' },
  { img: '/brands/hudson.png', name: 'Hudson' },
  { img: '/brands/hummer.png', name: 'Hummer' },
  { img: '/brands/hupmobile.png', name: 'Hupmobile' },
  { img: '/brands/hyundai.png', name: 'Hyundai' },
  { img: '/brands/ic-bus.png', name: 'IC Bus' },
  { img: '/brands/ih.png', name: 'IH' },
  { img: '/brands/ikco.png', name: 'IKCO' },
  { img: '/brands/infiniti.png', name: 'Infiniti' },
  { img: '/brands/innocenti.png', name: 'Innocenti' },
  { img: '/brands/intermeccanica.png', name: 'Intermeccanica' },
  { img: '/brands/international.png', name: 'International' },
  { img: '/brands/irizar.png', name: 'Irizar' },
  { img: '/brands/isdera.png', name: 'Isdera' },
  { img: '/brands/iso.png', name: 'Iso' },
  { img: '/brands/isuzu.png', name: 'Isuzu' },
  { img: '/brands/iveco.png', name: 'Iveco' },
  { img: '/brands/jac.png', name: 'Jac' },
  { img: '/brands/jaguar.png', name: 'Jaguar' },
  { img: '/brands/jawa.png', name: 'Jawa' },
  { img: '/brands/jba-motors.png', name: 'JBA Motors' },
  { img: '/brands/jeep.png', name: 'Jeep' },
  { img: '/brands/jensen.png', name: 'Jensen' },
  { img: '/brands/jetta.png', name: 'Jetta' },
  { img: '/brands/jmc.png', name: 'JMC' },
  { img: '/brands/kaiser.png', name: 'Kaiser' },
  { img: '/brands/kamaz.png', name: 'Kamaz' },
  { img: '/brands/karlmann-king.png', name: 'Karlmann King' },
  { img: '/brands/karma.png', name: 'Karma' },
  { img: '/brands/keating.png', name: 'Keating' },
  { img: '/brands/kenworth.png', name: 'Kenworth' },
  { img: '/brands/kia.png', name: 'Kia' },
  { img: '/brands/king-long.png', name: 'King Long' },
  { img: '/brands/koenigsegg.png', name: 'Koenigsegg' },
  { img: '/brands/ktm.png', name: 'KTM' },
  { img: '/brands/lada.png', name: 'Lada' },
  { img: '/brands/lagonda.png', name: 'Lagonda' },
  { img: '/brands/lamborghini.png', name: 'Lamborghini' },
  { img: '/brands/lancia.png', name: 'Lancia' },
  { img: '/brands/land-rover.png', name: 'Land Rover' },
  { img: '/brands/landwind.png', name: 'Landwind' },
  { img: '/brands/laraki.png', name: 'Laraki' },
  { img: '/brands/leapmotor.png', name: 'Leapmotor' },
  { img: '/brands/levc.png', name: 'LEVC' },
  { img: '/brands/lexus.png', name: 'Lexus' },
  { img: '/brands/leyland.png', name: 'Leyland' },
  { img: '/brands/li-auto.png', name: 'Li Auto' },
  { img: '/brands/lifan.png', name: 'Lifan' },
  { img: '/brands/ligier.png', name: 'Ligier' },
  { img: '/brands/lincoln.png', name: 'Lincoln' },
  { img: '/brands/lister.png', name: 'Lister' },
  { img: '/brands/lloyd.png', name: 'Lloyd' },
  { img: '/brands/lobini.png', name: 'Lobini' },
  { img: '/brands/lordstown.png', name: 'Lordstown' },
  { img: '/brands/lotus.png', name: 'Lotus' },
  { img: '/brands/lucid.png', name: 'Lucid' },
  { img: '/brands/luxgen.png', name: 'Luxgen' },
  { img: '/brands/lynk-and-co.png', name: 'Lynk & Co' },
  { img: '/brands/mack.png', name: 'Mack' },
  { img: '/brands/mahindra.png', name: 'Mahindra' },
  { img: '/brands/man.png', name: 'Man' },
  { img: '/brands/mansory.png', name: 'Mansory' },
  { img: '/brands/marcos.png', name: 'Marcos' },
  { img: '/brands/marlin.png', name: 'Marlin' },
  { img: '/brands/maserati.png', name: 'Maserati' },
  { img: '/brands/mastretta.png', name: 'Mastretta' },
  { img: '/brands/maxus.png', name: 'Maxus' },
  { img: '/brands/maybach.png', name: 'Maybach' },
  { img: '/brands/maz.png', name: 'Maz' },
  { img: '/brands/mazda.png', name: 'Mazda' },
  { img: '/brands/mazzanti.png', name: 'Mazzanti' },
  { img: '/brands/mclaren.png', name: 'McLaren' },
  { img: '/brands/melkus.png', name: 'Melkus' },
  { img: '/brands/mercedes-amg.png', name: 'Mercedes AMG' },
  { img: '/brands/mercedes-benz.png', name: 'Mercedes Benz' },
  { img: '/brands/mercury.png', name: 'Mercury' },
  { img: '/brands/merkur.png', name: 'Merkur' },
  { img: '/brands/mev.png', name: 'Mev' },
  { img: '/brands/mg.png', name: 'MG' },
  { img: '/brands/microcar.png', name: 'Microcar' },
  { img: '/brands/mini.png', name: 'Mini' },
  { img: '/brands/mitsubishi.png', name: 'Mitsubishi' },
  { img: '/brands/mitsuoka.png', name: 'Mitsuoka' },
  { img: '/brands/mk.png', name: 'MK' },
  { img: '/brands/morgan.png', name: 'Morgan' },
  { img: '/brands/morris.png', name: 'Morris' },
  { img: '/brands/mosler.png', name: 'Mosler' },
  { img: '/brands/navistar.png', name: 'Navistar' },
  { img: '/brands/nevs.png', name: 'NEVS' },
  { img: '/brands/nikola.png', name: 'Nikola' },
  { img: '/brands/nio.png', name: 'NIO' },
  { img: '/brands/nissan-gt-r.png', name: 'Nissan GT-R' },
  { img: '/brands/nissan-nismo.png', name: 'Nissan Nismo' },
  { img: '/brands/nissan.png', name: 'Nissan' },
  { img: '/brands/noble.png', name: 'Noble' },
  { img: '/brands/oldsmobile.png', name: 'Oldsmobile' },
  { img: '/brands/oltcit.png', name: 'Oltcit' },
  { img: '/brands/opel.png', name: 'Opel' },
  { img: '/brands/osca.png', name: 'Osca' },
  { img: '/brands/paccar.png', name: 'Paccar' },
  { img: '/brands/packard.png', name: 'Packard' },
  { img: '/brands/pagani.png', name: 'Pagani' },
  { img: '/brands/panhard.png', name: 'Panhard' },
  { img: '/brands/panoz.png', name: 'Panoz' },
  { img: '/brands/pegaso.png', name: 'Pegaso' },
  { img: '/brands/perodua.png', name: 'Perodua' },
  { img: '/brands/peterbilt.png', name: 'Peterbilt' },
  { img: '/brands/peugeot.png', name: 'Peugeot' },
  { img: '/brands/pgo.png', name: 'PGO' },
  { img: '/brands/pierce-arrow.png', name: 'Pierce Arrow' },
  { img: '/brands/pininfarina.png', name: 'Pininfarina' },
  { img: '/brands/plymouth.png', name: 'Plymouth' },
  { img: '/brands/polestar.png', name: 'Polestar' },
  { img: '/brands/pontiac.png', name: 'Pontiac' },
  { img: '/brands/porsche.png', name: 'Porsche' },
  { img: '/brands/praga.png', name: 'Praga' },
  { img: '/brands/premier.png', name: 'Premier' },
  { img: '/brands/prodrive.png', name: 'Prodrive' },
  { img: '/brands/proton.png', name: 'Proton' },
  { img: '/brands/qoros.png', name: 'Qoros' },
  { img: '/brands/radical.png', name: 'Radical' },
  { img: '/brands/ram.png', name: 'Ram' },
  { img: '/brands/rambler.png', name: 'Rambler' },
  { img: '/brands/ranz.png', name: 'Ranz' },
  { img: '/brands/renault-samsung.png', name: 'Renault Samsung' },
  { img: '/brands/renault.png', name: 'Renault' },
  { img: '/brands/rezvani.png', name: 'Rezvani' },
  { img: '/brands/riley.png', name: 'Riley' },
  { img: '/brands/rimac.png', name: 'Rimac' },
  { img: '/brands/rinspeed.png', name: 'Rinspeed' },
  { img: '/brands/rivian.png', name: 'Rivian' },
  { img: '/brands/roewe.png', name: 'Roewe' },
  { img: '/brands/rolls-royce.png', name: 'Rolls-Royce' },
  { img: '/brands/ronart.png', name: 'Ronart' },
  { img: '/brands/rossion.png', name: 'Rossion' },
  { img: '/brands/rover.png', name: 'Rover' },
  { img: '/brands/ruf.png', name: 'Ruf' },
  { img: '/brands/saab.png', name: 'Saab' },
  { img: '/brands/saic-motor.png', name: 'SAIC Motor' },
  { img: '/brands/saipa.png', name: 'Saipa' },
  { img: '/brands/saleen.png', name: 'Saleen' },
  { img: '/brands/saturn.png', name: 'Saturn' },
  { img: '/brands/scania.png', name: 'Scania' },
  { img: '/brands/scion.png', name: 'Scion' },
  { img: '/brands/seat.png', name: 'Seat' },
  { img: '/brands/setra.png', name: 'Setra' },
  { img: '/brands/shacman.png', name: 'Shacman' },
  { img: '/brands/simca.png', name: 'Simca' },
  { img: '/brands/singer.png', name: 'Singer' },
  { img: '/brands/singulato.png', name: 'Singulato' },
  { img: '/brands/sinotruk.png', name: 'Sinotruk' },
  { img: '/brands/sisu.png', name: 'Sisu' },
  { img: '/brands/skoda.png', name: 'Skoda' },
  { img: '/brands/smart.png', name: 'Smart' },
  { img: '/brands/soueast.png', name: 'Soueast' },
  { img: '/brands/spania-gta.png', name: 'Spania GTA' },
  { img: '/brands/spirra.png', name: 'Spira' },
  { img: '/brands/spyker.png', name: 'Spyker' },
  { img: '/brands/ssangyong.png', name: 'SSangYong' },
  { img: '/brands/ssc.png', name: 'SSC' },
  { img: '/brands/sterling.png', name: 'Sterling' },
  { img: '/brands/studebaker.png', name: 'Studebaker' },
  { img: '/brands/stutz.png', name: 'Stutz' },
  { img: '/brands/subaru.png', name: 'Subaru' },
  { img: '/brands/suffolk.png', name: 'Suffolk' },
  { img: '/brands/suzuki.png', name: 'Suzuki' },
  { img: '/brands/talbot.png', name: 'Talbot' },
  { img: '/brands/tata.png', name: 'Tata' },
  { img: '/brands/tatra.png', name: 'Tatra' },
  { img: '/brands/tauro.png', name: 'Tauro' },
  { img: '/brands/techart.png', name: 'Techart' },
  { img: '/brands/tesla.png', name: 'Tesla' },
  { img: '/brands/toyota-alphard.png', name: 'Toyota Alphard' },
  { img: '/brands/toyota-century.png', name: 'Toyota Century' },
  { img: '/brands/toyota-crown.png', name: 'Toyota Crown' },
  { img: '/brands/toyota.png', name: 'Toyota' },
  { img: '/brands/tramontana.png', name: 'Tramontana' },
  { img: '/brands/trion.png', name: 'Trion' },
  { img: '/brands/triumph.png', name: 'Triumph' },
  { img: '/brands/troller.png', name: 'Troller' },
  { img: '/brands/tucker.png', name: 'Tucker' },
  { img: '/brands/tvr.png', name: 'TVR' },
  { img: '/brands/uaz.png', name: 'UAZ' },
  { img: '/brands/ud.png', name: 'UD' },
  { img: '/brands/ultima.png', name: 'Ultima' },
  { img: '/brands/vandenbrink.png', name: 'Vandenbrink' },
  { img: '/brands/vauxhall.png', name: 'Vauxhall' },
  { img: '/brands/vector.png', name: 'Vector' },
  { img: '/brands/vencer.png', name: 'Vencer' },
  { img: '/brands/venturi.png', name: 'Venturi' },
  { img: '/brands/venucia.png', name: 'Venucia' },
  { img: '/brands/vinfast.png', name: 'Vinfast' },
  { img: '/brands/vlf.png', name: 'VLF' },
  { img: '/brands/volkswagen.png', name: 'Volkswagen' },
  { img: '/brands/volvo.png', name: 'Volvo' },
  { img: '/brands/w-motors.png', name: 'W Motors' },
  { img: '/brands/wanderer.png', name: 'Wanderer' },
  { img: '/brands/wartburg.png', name: 'Wartburg' },
  { img: '/brands/weltmeister.png', name: 'Weltmeister' },
  { img: '/brands/western-star.png', name: 'Western Star' },
  { img: '/brands/westfield.png', name: 'Westfield' },
  { img: '/brands/wey.png', name: 'Wey' },
  { img: '/brands/wiesmann.png', name: 'Wiesmann' },
  { img: '/brands/willys-overland.png', name: 'Willys Overland' },
  { img: '/brands/workhorse.png', name: 'Workhorse' },
  { img: '/brands/wuling.png', name: 'Wuling' },
  { img: '/brands/xpeng.png', name: 'Xpeng' },
  { img: '/brands/yulon.png', name: 'Yulon' },
  { img: '/brands/yutong.png', name: 'Yutong' },
  { img: '/brands/zarooq-motors.png', name: 'Zarooq Motors' },
  { img: '/brands/zastava.png', name: 'Zastava' },
  { img: '/brands/zaz.png', name: 'Zaz' },
  { img: '/brands/zeekr.png', name: 'Zeekr' },
  { img: '/brands/zenos.png', name: 'Zenos' },
  { img: '/brands/zenvo.png', name: 'Zenvo' },
  { img: '/brands/zhongtong.png', name: 'Zhongtong' },
  { img: '/brands/zinoro.png', name: 'Zinoro' },
  { img: '/brands/zotye.png', name: 'Zotye' },
  

].sort((a, b) => a.name.localeCompare(b.name));

// Create a custom event for scrolling to CTA
export const scrollToCTAEvent = new CustomEvent('scrollToCTA');

// Helper function to compress image
const compressImage = async (file: File, maxWidth: number = 1200, quality: number = 0.8): Promise<string> => {
  return new Promise(async (resolve) => {
    let processedFile = file;
    
    if (file.type === 'image/heic' || file.type === 'image/heif' || file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
      try {
        // You'll need to add heic2any library
        processedFile = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.8
        }) as File;
      } catch (error) {
        console.error('HEIC conversion error:', error);
      }
    }

    // Then proceed with normal compression
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    const img = new Image();
    
    img.onload = () => {
      const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
      const newWidth = img.width * ratio;
      const newHeight = img.height * ratio;
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      
      // Convert to JPEG for consistent format
      const compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
      
      resolve(compressedDataUrl);
    };
    
    img.src = URL.createObjectURL(processedFile);
  });
};

// Helper function to get client information
const getClientInfo = async () => {
  try {
    // Get IP address
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipResponse.json();
    
    // Get location data from IP
    const locationResponse = await fetch(`https://ipapi.co/${ipData.ip}/json/`);
    const locationData = await locationResponse.json();
    
    // Get browser information
    const browserInfo = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      cookieEnabled: navigator.cookieEnabled,
      onLine: navigator.onLine,
      screenResolution: `${screen.width}x${screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      referrer: document.referrer || 'Direct',
      currentUrl: window.location.href,
      timestamp: new Date().toISOString()
    };

    return {
      ip: ipData.ip,
      location: {
        city: locationData.city || 'Unknown',
        region: locationData.region || 'Unknown',
        country: locationData.country_name || 'Unknown',
        latitude: locationData.latitude,
        longitude: locationData.longitude,
        timezone: locationData.timezone || 'Unknown'
      },
      browser: browserInfo
    };
  } catch (error) {
    console.error('Error getting client info:', error);
    return {
      ip: 'Unknown',
      location: {
        city: 'Unknown',
        region: 'Unknown',
        country: 'Unknown',
        latitude: null,
        longitude: null,
        timezone: 'Unknown'
      },
      browser: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        cookieEnabled: navigator.cookieEnabled,
        onLine: navigator.onLine,
        screenResolution: `${screen.width}x${screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        referrer: document.referrer || 'Direct',
        currentUrl: window.location.href,
        timestamp: new Date().toISOString()
      }
    };
  }
};

export const CarForm: React.FC = () => {
  const { city } = useAppContext();
  const ctaRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);  
  const [currentStep, setCurrentStep] = useState(1);
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [year, setYear] = useState('');
  const [mileage, setMileage] = useState('');
  const [plate, setPlate] = useState('');
  const [photos, setPhotos] = useState<File[]>([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [desiredPrice, setDesiredPrice] = useState(5000);
  const [error, setError] = useState('');
  const [showPhotoWarning, setShowPhotoWarning] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [brandSearch, setBrandSearch] = useState('');
  const [showBrandDropdown, setShowBrandDropdown] = useState(false);
  const [clientInfo, setClientInfo] = useState<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Get client information on component mount
  useEffect(() => {
    const fetchClientInfo = async () => {
      const info = await getClientInfo();
      setClientInfo(info);
    };
    fetchClientInfo();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowBrandDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const steps = [
    { number: 1, title: 'Inserisci i dati' },
    { number: 2, title: 'Dettagli veicolo' },
    { number: 3, title: 'Conferma' }
  ];

  const filteredBrands = brands.filter(b => 
    b.name.toLowerCase().includes(brandSearch.toLowerCase())
  );

  const validImageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const newPhotos = Array.from(e.target.files);
      
      // Limit to maximum 5 photos total
      const currentPhotoCount = photos.length;
      const maxPhotos = 5;
      const maxFileSize = 10 * 1024 * 1024; // 10MB per file
      
      if (currentPhotoCount >= maxPhotos) {
        alert(`Massimo ${maxPhotos} foto consentite`);
        return;
      }
      
      // Filter valid photos
      const validPhotos = newPhotos.filter(file => {
        if (!validImageTypes.includes(file.type.toLowerCase())) {
          alert(`Il formato ${file.type} non è supportato. Usa JPEG, PNG, WebP o HEIC.`);
          return false;
        }
        if (file.size > maxFileSize) {
          alert(`Il file ${file.name} è troppo grande. Dimensione massima: 10MB`);
          return false;
        }
        if (!file.type.startsWith('image/')) {
          alert(`Il file ${file.name} non è un'immagine valida`);
          return false;
        }
        return true;
      });
      
      // Take only the number of photos that fit within the limit
      const photosToAdd = validPhotos.slice(0, maxPhotos - currentPhotoCount);
      
      if (photosToAdd.length < newPhotos.length) {
        alert(`Aggiunte solo ${photosToAdd.length} foto per rispettare il limite di ${maxPhotos} foto totali/formato.`);
      }
      
      setPhotos(prev => [...prev, ...photosToAdd]);
    }
  };

  const removePhoto = (index: number) => {
    setPhotos(prev => prev.filter((_, i) => i !== index));
  };

  const handleBrandSelect = (selectedBrand: string) => {
    setBrand(selectedBrand);
    setModel(''); // Reset model when brand changes
    setShowBrandDropdown(false);
    setBrandSearch('');
  };

  const formatDate = (input: string) => {
    // Remove any non-numeric characters
    const numbers = input.replace(/\D/g, '');
    
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 4) {
      return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    } else {
      return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDate(e.target.value);
    setYear(formatted);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Basic validation
    if (!brand || !model || !year || !mileage || !name || (!email && !phone)) {
      setError('Per favore compila tutti i campi obbligatori');
      return;
    }

    // Show photo warning if no photos uploaded
    if (photos.length === 0) {
      setShowPhotoWarning(true);
      const proceed = window.confirm('La valutazione senza foto potrebbe essere meno accurata. Vuoi procedere comunque?');
      if (!proceed) {
        return;
      }
    }

    setIsLoading(true);
    setError('');

    try {
      // Move to confirmation step first for better UX
      setCurrentStep(3);

      // Convert and compress photos to base64 if any
      const photoPromises = photos.map(async (file) => {
        try {
          // Compress the image before converting to base64
          const compressedDataUrl = await compressImage(file, 800, 0.7);
          return compressedDataUrl;
        } catch (error) {
          console.error('Error compressing image:', error);
          // Fallback to original file if compression fails
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        }
      });

      const photoBase64Array = await Promise.all(photoPromises);

      // Prepare vehicle data
      const vehicleData = {
        name,
        email,
        phone,
        desiredPrice,
        vehicle: {
          brand: brand,
          model,
          version: '', // Add if you have this field
          year: year, // Extract year from dd/mm/yyyy
          mileage,
          plate
        },
        photos: photoBase64Array,
        clientInfo: clientInfo
      };

      // Send user email if email is provided
      if (email) {
        const userEmailResponse = await fetch('/.netlify/functions/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
            email,
            vehicle: vehicleData.vehicle,
            logo_url: brands.find(b => b.name === brand)?.img || '',
          })
        });

        if (!userEmailResponse.ok) {
          throw new Error('Failed to send user email');
        }
      }

      // Send admin notification
      const adminEmailResponse = await fetch('/.netlify/functions/send-admin-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerData: {
            name,
            email: email || 'Not provided',
            phone: phone || 'Not provided',
            desiredPrice
          },
          vehicleData: {
            brand,
            model,
            year: year, // Extract year from dd/mm/yyyy
            mileage,
            plate: plate || 'Not provided'
          },
          clientInfo: clientInfo,
          attachments: photoBase64Array.map((base64, index) => ({
            filename: `vehicle-photo-${index + 1}.jpg`,
            content: base64
          }))
        })
      });

      if (!adminEmailResponse.ok) {
        const errorData = await adminEmailResponse.json();
        console.error('Failed to send admin notification:', errorData);
        throw new Error('Failed to send admin notification');
      }

      setSubmitted(true);
      setError('');

    } catch (err) {
      console.error('Submission error:', err);
      setError('Invio del modulo non riuscito. Riprova di nuovo.');
      setCurrentStep(2);
    } finally {
      setIsLoading(false);
    }
  };

  const renderSteps = () => (
    <div className="flex justify-between mb-8">
      {steps.map((step) => (
        <div key={step.number} className="relative flex flex-col items-center">
          <div 
            className={`w-10 h-10 rounded-full flex items-center justify-center ${
              currentStep >= step.number 
                ? 'bg-blue-600 text-white' 
                : 'bg-gray-200 text-gray-600'
            }`}
          >
            {step.number}
      </div>
          <span className="mt-2 text-sm font-medium text-gray-600">
            {step.title}
          </span>
          {step.number < steps.length && (
            <div 
              className={`absolute top-5 left-full w-full h-[2px] -ml-2 ${
                currentStep > step.number ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            />
          )}
      </div>
      ))}
    </div>
  );

  // Scroll function that can be used from other components
  const scrollToCTA = () => {
    ctaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // Add event listener for CTA scroll
  useEffect(() => {
    const handleScrollToCTA = () => scrollToCTA();
    window.addEventListener('scrollToCTA', handleScrollToCTA);
    return () => window.removeEventListener('scrollToCTA', handleScrollToCTA);
  }, []);

  if (submitted) {
    return (
      <div className="p-6 text-center bg-white rounded-lg ">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="mb-6">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="mb-4 text-2xl font-bold text-green-600">Grazie {name}!</h3>
            <p className="mb-4 text-gray-700">
              Abbiamo ricevuto la tua richiesta di valutazione per la tua <strong>{brand} {model}</strong>. 
              Il nostro team di esperti analizzerà i dettagli del tuo veicolo e ti invierà a breve una valutazione dettagliata.
            </p>
          </div>
          
          <div className="p-4 mb-6 border-l-4 border-blue-400 rounded-lg bg-blue-50">
            <p className="font-medium text-blue-800">✅ Cosa succede ora?</p>
            <ul className="mt-2 text-sm text-left text-blue-700">
              <li>• Analizzeremo i dettagli del tuo veicolo</li>
              <li>• Valuteremo le condizioni di mercato</li>
              <li>• Ti contatteremo entro 24 ore con la nostra offerta</li>
            </ul>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              setSubmitted(false);
              setCurrentStep(1);
              setBrand('');
              setModel('');
              setYear('');
              setMileage('');
              setPlate('');
              setPhotos([]);
              setName('');
              setEmail('');
              setPhone('');
            }}
            className="px-6 py-3 text-white bg-[#fdc751] rounded-lg hover:bg-[#fdc751]/90 font-semibold"
          >
            Valuta un'altra auto
          </motion.button>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div ref={ctaRef} id="quote-section" className="scroll-mt-20">
        {renderSteps()}
        
        <form onSubmit={handleSubmit} className="space-y-6">
          {currentStep === 1 && (
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="space-y-4"
            >
              <div ref={dropdownRef}>
                <label className="block mb-1 text-sm font-medium text-gray-700">Marca</label>
                <div className="relative">
                  <div
                    onClick={() => setShowBrandDropdown(!showBrandDropdown)}
                    className="relative flex items-center w-full px-4 py-2 border border-gray-300 rounded-md cursor-pointer hover:border-blue-500"
                  >
                    {brand ? (
                      <div className="flex items-center">
                        <img 
                          src={brands.find(b => b.name === brand)?.img}
                          alt={brand}
                          className="object-contain w-8 h-8 mr-2 mix-blend-multiply"
                        />
                        <span>{brand}</span>
                    </div>
                    ) : (
                      <span className="text-gray-500">Seleziona marca...</span>
                    )}
                    <ChevronDown className={`ml-auto h-5 w-5 text-gray-400 transition-transform ${showBrandDropdown ? 'transform rotate-180' : ''}`} />
                  </div>

                  <AnimatePresence>
                    {showBrandDropdown && (
                      <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg"
                      >
                        <div className="p-2">
                          <div className="relative mb-2">
                            <input
                              type="text"
                              value={brandSearch}
                              onChange={(e) => setBrandSearch(e.target.value)}
                              placeholder="Cerca marca..."
                              className="w-full py-2 pl-8 pr-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                            />
                            <Search className="absolute left-2 top-2.5 h-5 w-5 text-gray-400" />
                  </div>
                          <div className="overflow-y-auto max-h-60">
                            {filteredBrands.map((b) => (
                              <motion.div
                                key={b.name}
                                whileHover={{ backgroundColor: '#F3F4F6' }}
                                onClick={() => handleBrandSelect(b.name)}
                                className={`flex items-center p-2 cursor-pointer rounded-md ${
                                  brand === b.name ? 'bg-blue-50' : ''
                                }`}
                              >
                                <img 
                                  src={b.img} 
                                  alt={b.name}
                                  className="object-contain w-8 h-8 mix-blend-multiply"
                                />
                                <span className="ml-2">{b.name}</span>
                              </motion.div>
                            ))}
                  </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Modello</label>
                <input
                  type="text"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Anno di immatricolazione</label>
                  <input
                  type="text"
                  value={year}
                  onChange={handleYearChange}
                  placeholder="gg/mm/aaaa"
                  maxLength={10}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </motion.div>
          )}

          {currentStep === 2 && (
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="space-y-4"
            >
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Chilometraggio (km)</label>
                <input
                  type="number"
                  value={mileage}
                  onChange={(e) => setMileage(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Targa</label>
                <input
                  type="text"
                  value={plate}
                  onChange={(e) => setPlate(e.target.value.toUpperCase())}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              
              {/* Prezzo Desiderato Slider */}
              <div>
                <label className="flex items-center mb-2 text-sm font-medium text-gray-700">
                  <DollarSign className="w-4 h-4 mr-2 text-green-600" />
                  Prezzo Desiderato (€)
                </label>
                <div className="p-4 rounded-lg bg-gray-50">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-gray-600">€1.000</span>
                    <span className="text-lg font-bold text-green-600">€{desiredPrice.toLocaleString()}</span>
                    <span className="text-sm text-gray-600">€50.000</span>
                  </div>
                  <input
                    type="range"
                    min="500"
                    max="50000"
                    step="500"
                    value={desiredPrice}
                    onChange={(e) => setDesiredPrice(Number(e.target.value))}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
                    style={{
                      background: `linear-gradient(to right, #10b981 0%, #10b981 ${(desiredPrice - 1000) / 490 * 100}%, #e5e7eb ${(desiredPrice - 1000) / 490 * 100}%, #e5e7eb 100%)`
                    }}
                  />
                  <div className="flex justify-between mt-1 text-xs text-gray-500">
                    <span>€1k</span>
                    <span>€10k</span>
                    <span>€25k</span>
                    <span>€50k</span>
                  </div>
                </div>
                <p className="mt-2 text-sm text-gray-600">
                  Indicaci il prezzo che vorresti realizzare. Ti aiuteremo a raggiungere il miglior risultato possibile.
                </p>
              </div>

              <div>
                <label className="flex items-center mb-1 text-sm font-medium text-gray-700">
                  Foto del veicolo
                  <Info 
                    className="w-4 h-4 ml-2 text-gray-400 cursor-help"
                    onMouseEnter={() => setShowPhotoWarning(true)}
                    onMouseLeave={() => setShowPhotoWarning(false)}
                  />
                </label>
                {showPhotoWarning && (
                  <p className="mb-2 text-sm text-yellow-600">
                    Aggiungere foto ci aiuta a fornire una valutazione più accurata
                  </p>
                )}
                <div className="mt-1">
                  <label className="flex items-center justify-center w-full p-4 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer hover:border-blue-500">
                    <input
                      type="file"
                      multiple
                      accept="image/*, .heic, .heif"
                      onChange={handlePhotoUpload}
                      className="hidden"
                    />
                    <Upload className="w-6 h-6 mr-2 text-gray-400" />
                    <span className="text-gray-600">Carica foto</span>
                  </label>
                </div>
                {photos.length > 0 && (
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    {photos.map((photo, index) => (
                      <div key={index} className="relative">
                        <img
                          src={URL.createObjectURL(photo)}
                          alt={`Photo ${index + 1}`}
                          className="object-cover w-full h-32 rounded"
                        />
                        <button
                          type="button"
                          onClick={() => removePhoto(index)}
                          className="absolute p-1 text-white bg-red-500 rounded-full top-1 right-1 hover:bg-red-600"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Nome</label>
                  <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                    required
                  />
              </div>
                  <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
                  </div>
                  <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">Telefono</label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </motion.div>
          )}

          {error && (
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="p-4 rounded-lg bg-red-50"
            >
              <div className="flex items-center">
                <AlertCircle className="w-5 h-5 mr-2 text-red-500" />
                <p className="text-sm text-red-600">{error}</p> 
              </div>
            </motion.div>
          )}

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="sticky bottom-0 flex justify-between p-4 space-x-4 bg-white shadow-lg md:relative md:p-0 md:shadow-none"
          >
            {currentStep > 1 && (
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                type="button"
                onClick={() => setCurrentStep(prev => prev - 1)}
                className="flex-1 px-6 py-3 text-blue-600 bg-white border-2 border-blue-600 rounded-lg hover:bg-blue-50"
              >
                Indietro
              </motion.button>
            )}
            {currentStep < 2 ? (
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                type="button"
                onClick={() => setCurrentStep(2)}
                disabled={!brand || !model || !year}
                className="flex-1 px-6 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Passaggio successivo
              </motion.button>
            ) : (
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                type="submit"
                disabled={isLoading}
                className="flex items-center justify-center flex-1 px-6 py-3 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <>
                    <svg className="w-5 h-5 mr-2 animate-spin" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Invio in corso...
                  </>
                ) : (
                  city ? `Ottieni la tua valutazione` : 'Ottieni la tua valutazione'
                )}
              </motion.button>
            )}
          </motion.div>
        </form>
      </div>
    </div>
  );
};

// Export the scroll function for use in other components
export const scrollToCarFormCTA = () => {
  const formSection = document.getElementById('quote-section');
  if (formSection) {
    formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};